module.exports = __webpack_public_path__ + "img/zhongfengxian.cc5cffc6.png";